import { Location } from "@angular/common";
import { Component, inject, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router, Routes } from "@angular/router";
import { hasValue } from "app/shared/global.functions";
import { Organisation } from "app/shared/model";
import { OrganisationServiceProxy } from "app/shared/services/organisation-service.proxy";
import { UserConfigService } from "app/shared/services/user-config.service";

@Component({
    selector: 'organisation-resolver',
    standalone: true,
    template: ``,
    styles: [`body,html,*{ background-color: #040f32; }`], // 000b2d , 020916 = 040f24
    encapsulation: ViewEncapsulation.None,
    // imports: [],
})
export class OrganisationResolverComponent implements OnInit
{
    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);
    private readonly location = inject(Location)

    private readonly _userConfigService = inject(UserConfigService);
    private readonly _orgServiceProxy = inject(OrganisationServiceProxy);

    private triggered = false;

    ngOnInit()
    {
        this.checkUrl();
    }

    private routeExists(path: string): boolean
    {
        return this.checkPaths(this.router.config, path);
    }

    private checkPaths(routes: Routes, path: string): boolean
    {
        return routes.some((route) => {
            if (route.path === path) {
                return true;
            }

            if (route.children) {
                return this.checkPaths(route.children, path);
            }

            return false;
        });
    }

    checkUrl(): void
    {
        if (this.triggered) {
            return;
        }

        let paths = this.route.snapshot.url;
        let redirectPaths = paths.map(p => p.path); // .join('/');
        redirectPaths.shift(); // remove the first path

        if (this.routeExists(paths[0].path)) {
            return;
        }

        this.triggered = true;
        console.debug('CHECKURL: ', this.location.path());

        const orgUrl = window.location.hostname + '/' + paths[0].path;
        this._orgServiceProxy.getOrganisationByUrl(orgUrl).subscribe((org: Organisation) => {
            console.log('Organisation:', org);
            // this._userService.setOrganisation(org);
            if (hasValue(org)) {
                // Save the org and it's theme details to the user service
                const localConfig = { organisationId: org.id, defaultTheme: org.defaultTheme };
                this._userConfigService.config = { localConfig };

                // this._customThemeService.getTheme(org.defaultTheme, '');
                // redirect to the sub-path that was requested.
                this.router.navigate(redirectPaths);

                return;
            }

            if (this.routeExists(redirectPaths[0])) {
                this.router.navigate(redirectPaths);
                return;
            }

            this.router.navigate(['error', '404']);
        });
    }
}
